export default class UserRegisterRequest {
  email: string;
  token: string;
  password: string;
  name: string;
  constructor(email: string, token: string, password: string, name: string) {
    this.email = email;
    this.token = token;
    this.password = password;
    this.name = name;
  }
}
